















import { Component, Ref } from 'vue-property-decorator';
import { StepperEvents } from '../../constants/events';
import { Routes } from '../../constants/routes';
import ConstructionTypeForm from '../../components/forms/ConstructionTypeForm.vue';
import StepFormWideContent from '../../components/StepFormWideContent.vue';
import { Form } from '../../components/forms/Form';
import { mixins } from 'vue-class-component';
import InvalidFormMixin from '../../mixins/InvalidFormMixin';
import { useI18nInstance } from '@/main';

@Component({
        components: {
            StepFormWideContent,
            ConstructionTypeForm,
        },
    })
    export default class TypeStep extends mixins(InvalidFormMixin) {

        public formConstructionTypeIsInvalid = false;

        @Ref('constructionTypeForm')
        private readonly constructionTypeFormComponent!: Form;

        public get isFormInvalid(): boolean {
            return this.formConstructionTypeIsInvalid;
        }

        public mounted() {
            this.$eventBus.$emit(StepperEvents.ActivateStep, 1);
        }

        public validationChangeConstructionType(invalid: boolean) {
            this.formConstructionTypeIsInvalid = invalid;
        }

        public next() {
            this.constructionTypeFormComponent.touch();
            if (this.isFormInvalid) {
                this.showInvalidFormToast();
            } else {
                this.constructionTypeFormComponent.save();
                this.$router.push({ name: Routes.WhereStep, query: { lang: useI18nInstance.locale } });
            }
        }

    }
